module.exports = __webpack_public_path__ + "img/minus.a90e355b.svg";